import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { MultiSelect } from "primereact/multiselect";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const FilterInput = ({ id, value, setSelected, options }) => {
    const ref = useRef();
    const { t } = useTranslation();
    const [selectAll, setSelectAll] = useState(true);

    useEffect(() => {
        if (options.length && (value.length === options.length)){
            setSelectAll(true);
            ref.current.getElement().getElementsByClassName("p-multiselect-items-label")[0].textContent = t("marketplace.allSelected");
        } else {
            setSelectAll(false);
        }
    }, [value.length, options.length, t]);

    const onChange = e => {
        e.stopPropagation();
        setSelected(e.value);
    };

    const panelFooterTemplate = () => {
        return (
            <div>
                <div className='mkt-button mkt-btn-ok mb-2'>
                    <Button onClick={() => ref.current.hide()} label={t("marketplace.ok")} />
                </div>
                {/* <div className='mkt-button mkt-btn-clear'>
                    <Button onClick={() => {
                        setSelected([]);
                    }} label={t("marketplace.clear")} />
                </div> */}
            </div>
        );
    };

    return (
        <>
            <MultiSelect
                id={id}
                ref={ref}
                value={value}
                onChange={onChange}
                options={options}
                placeholder={t("marketplace.chooseFilter")}
                showSelectAll
                selectAll={selectAll}
                maxSelectedLabels={1}
                panelClassName='mkt-multiselect-popup'
                panelFooterTemplate={panelFooterTemplate}
                className='mkt-multiselect'
                selected
                panelHeaderTemplate={() => (
                    <div className="p-multiselect-header" onClick={() => {
                        if (!selectAll) setSelected(options?.map(e => e.value));
                        else setSelected([]);
                    }}
                    >
                        <div className='p-multiselect-item'>
                            <Checkbox checked={selectAll} />
                            <span className='ml-2'>{t("marketplace.allSelected")}</span>
                        </div>
                    </div>
                )}
            />
        </>
    );
};

export default FilterInput;
